import BattleVideo from './BattleVideo';

export default BattleVideo;
